var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatTeardrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3C13.1859 3.00364 10.0086 4.32177 7.66518 6.66518C5.32177 9.0086 4.00364 12.1859 4 15.5V26C4 26.5304 4.21071 27.0391 4.58579 27.4142C4.96086 27.7893 5.46957 28 6 28H16.5C19.8152 28 22.9946 26.683 25.3388 24.3388C27.683 21.9946 29 18.8152 29 15.5C29 12.1848 27.683 9.00537 25.3388 6.66117C22.9946 4.31696 19.8152 3 16.5 3ZM16.5 26H6V15.5C6 13.4233 6.61581 11.3932 7.76957 9.66651C8.92332 7.9398 10.5632 6.59399 12.4818 5.79926C14.4004 5.00454 16.5116 4.79661 18.5484 5.20175C20.5852 5.6069 22.4562 6.60693 23.9246 8.07538C25.3931 9.54383 26.3931 11.4148 26.7982 13.4516C27.2034 15.4884 26.9955 17.5996 26.2007 19.5182C25.406 21.4368 24.0602 23.0767 22.3335 24.2304C20.6068 25.3842 18.5767 26 16.5 26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatTeardrop);
export default __webpack_public_path__ + "static/media/chat-teardrop.7a35bacb1c8f333caeacb2e02d3f7f5c.svg";
export { ForwardRef as ReactComponent };